import { Command } from "commander";
import chalk from "chalk";
import { generateMigrationPlan } from "../upgrade/migrationPlanner.js";
import type { MigrationPlan } from "../models/MigrationPlan.js";

const COMPLEXITY_COLOR: Record<string, chalk.Chalk> = {
  LOW: chalk.green,
  MEDIUM: chalk.yellow,
  HIGH: chalk.red,
};

export const migrateCommand = new Command("migrate")
  .description("Generate a migration plan between two React Native versions")
  .argument("<from>", "Source React Native version (e.g. 0.72.0)")
  .argument("<to>", "Target React Native version (e.g. 0.75.0)")
  .option("--json", "Output in JSON format")
  .action(async (from: string, to: string, options: { json?: boolean }) => {
    try {
      const plan: MigrationPlan = generateMigrationPlan(from, to);

      if (options.json) {
        console.log(JSON.stringify(plan, null, 2));
        process.exit(0);
        return;
      }

      const complexityColor = COMPLEXITY_COLOR[plan.estimatedComplexity] ?? chalk.white;

      console.log();
      console.log(chalk.bold.underline(`Migration Plan: ${plan.fromVersion} → ${plan.toVersion}`));
      console.log();
      console.log(
        `  Complexity:   ${complexityColor(plan.estimatedComplexity)}`
      );
      console.log(`  Phases:       ${chalk.cyan(plan.phases.length)}`);
      if (plan.dependencyUpdates.length > 0) {
        console.log(`  Dep Updates:  ${chalk.cyan(plan.dependencyUpdates.length)}`);
      }
      console.log();

      for (const phase of plan.phases) {
        console.log(chalk.bold.underline(phase.name));
        console.log(chalk.dim(`  ${phase.description}`));
        console.log();
        for (const step of phase.steps) {
          const required = step.required ? chalk.cyan("[required]") : chalk.dim("[optional]");
          console.log(`  ${step.order}. ${step.description} ${required}`);
          if (step.command) {
            console.log(`     ${chalk.dim("$")} ${chalk.cyan(step.command)}`);
          }
        }
        console.log();
      }

      if (plan.dependencyUpdates.length > 0) {
        console.log(chalk.bold("Dependency Updates"));
        for (const dep of plan.dependencyUpdates) {
          console.log(
            `  ${chalk.yellow("→")} ${dep.name}  ${chalk.dim(dep.from)} → ${chalk.green(dep.to)}`
          );
        }
        console.log();
      }

      console.log(chalk.bold("Validation Steps"));
      for (const step of plan.validationSteps) {
        console.log(`  ${chalk.dim("·")} ${step}`);
      }
      console.log();
    } catch (err: any) {
      if (options.json) {
        console.log(JSON.stringify({ success: false, error: err?.message }, null, 2));
      } else {
        console.log(chalk.red(`✖ ${err?.message || "Unknown error"}`));
      }
      process.exit(1);
    }
  });
